import "shared/ui/toolbar/tools/layertreeAndEdit/layerContent/layerContent.css";

import { apm } from "@elastic/apm-rum";
import { AddOutlined, Delete } from "@mui/icons-material";
import { Box, Button, IconButton, TextField } from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { monitor } from "shared/common/services/apm-logging";
import { defaultStore } from "shared/common/stores/defaultStore";
import { sidebarStore } from "shared/common/stores/sidebarStore";

export default function CreateGroup() {
  const darkTheme = defaultStore((state) => state.darkTheme);

  const changeSaveButtonStateOnAddNewLayers = sidebarStore(
    (state) => state.changeSaveButtonStateOnAddNewLayers
  );
  const newLayerGroupList = sidebarStore((state) => state.newLayerGroupList);
  const changeNewLayerGroupList = sidebarStore(
    (state) => state.changeNewLayerGroupList
  );

  const { t } = useTranslation();

  //add new row with group name
  const addNewGroupRow = () => {
    changeNewLayerGroupList([...newLayerGroupList, ""]);
  };

  //change group name and check if can save
  const changeGroupName = (value: string, position: number) => {
    newLayerGroupList[position] = value;
    if (value === "") {
      checkIfCanSave();
    }
  };

  //delete group row
  const deleteGroupRow = (position: number) => {
    changeNewLayerGroupList(
      newLayerGroupList.filter((item, index) => index !== position)
    );
  };

  //check if can save groups or not
  const checkIfCanSave = () => {
    if (newLayerGroupList.join("").length > 0) {
      changeSaveButtonStateOnAddNewLayers(true);
    } else {
      changeSaveButtonStateOnAddNewLayers(false);
    }
  };

  //check if can save
  useEffect(() => {
    checkIfCanSave();
  }, [newLayerGroupList.length]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "calc(100% - 16px)",
        overflow: "auto",
        paddingY: 1,
        gap: 3,
      }}
    >
      <Box
        sx={{
          marginTop: 1,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        {newLayerGroupList.map((item: string, index: number) => (
          <Box
            key={`${index}_${item}`}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <TextField
              color="primary"
              sx={{
                width: { xs: "calc(100% - 56px)", md: "50%" },
              }}
              defaultValue={item}
              onChange={(event) => changeGroupName(event.target.value, index)}
              onBlur={() => checkIfCanSave()}
              size="small"
              label={t("create_group.group_name")}
              variant="outlined"
            />
            {index > 0 && (
              <IconButton
                onClick={() =>
                  monitor(apm, "delete-new-group | Add", () =>
                    deleteGroupRow(index)
                  )
                }
                sx={{ color: darkTheme ? "white" : "darkblue.main" }}
              >
                <Delete />
              </IconButton>
            )}
          </Box>
        ))}
        <Button
          variant="outlined"
          sx={{
            width: "fit-content",
            borderColor: darkTheme ? "white" : "darkblue.main",
            color: darkTheme ? "white" : "darkblue.main",
          }}
          onClick={() => monitor(apm, "add-new-group | Add", addNewGroupRow)}
        >
          <AddOutlined fontSize="small" />
          {t("manage_layers.button_add")}
        </Button>
      </Box>
    </Box>
  );
}
